<template>
  <div id="bg-image">
    <another-account-login />
  </div>
</template>

  <script>
  import AnotherAccountLogin from '../process/Register/AnotherAccountLogin.vue';
    export default {
      name: 'UseAnotherAccount',
      components: {
        AnotherAccountLogin,
      },
    };
  </script>

  <style scoped>
  </style>
